export default __webpack_public_path__ + "static/media/question6.9db1473d.svg";